import { Component } from '@angular/core';

import {
    CategoryAction,
    CategoryDisplayAs,
    EventCentreHookService,
} from '../core';

import { TranslationKeyMap } from './event-centre-dialog.i18n';
import { EventCentreDialogService } from './event-centre-dialog.service';

@Component({
    selector: 'cmps-event-centre-dialog',
    templateUrl: './event-centre-dialog.component.html',
    host: {
        class: 'cmps-event-centre-dialog',
    },
})
export class EventCentreDialogComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _CategoryDisplayAs = CategoryDisplayAs;

    constructor(
        /** @private */ readonly _service: EventCentreDialogService,
        private readonly _actionHookService: EventCentreHookService,
    ) {}

    /** @private */
    _onCategoryActionClick(action: CategoryAction): void {
        this._actionHookService.categoryActionInvoked(
            this._service.state.category,
            action,
            this._service.state.filteredItems,
        );

        this._actionHookService.categoryActionInvoked2(
            this._service.state.category,
            action,
            this._service.state.filteredItems,
            this._service,
        );
    }
}
